import { useState, useEffect, useRef, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./style.scss";
import { Box, Container, Grid, LinearProgress } from "@material-ui/core";
import {
  useFetchApi,
  Config,
  useRedirect,
  configurator,
  formatPhoneNumber,
} from "@itarget/shared";
import {
  auth,
  offers,
  setting as settingRedux,
  theme as themeRedux,
} from "../../redux";

import Header from "../Header";
import Footer from "../Footer/Footer";
import { makeStyles } from "@material-ui/styles";
import MobileReturn from "../MobileReturn";
import { useAssociationId } from "../../hooks/useAssociationId";
import { buildStatusAssociatedUrl } from "../../utils/association";

const useStyles = makeStyles((theme) => ({
  LinearProgress: {
    borderRadius: "0 0 4px 4px",
    height: theme.spacing(0.5),
  },
}));

const Layout = ({ children, isLoading = false, mobileReturn, bodyClassname }) => {
  const styles = useStyles();
  const { current: windowWidth } = useRef(window.innerWidth);
  const { goTo } = useRedirect();
  const routeParams = useParams();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const user = useSelector((state) => state.auth.user);
  const shoppingCarts = useSelector((state) => state.offers.shoppingCarts);
  const center_cost_id = useSelector((state) => state.auth.cc);
  const selectedLang = useSelector((state) => state.language.lang);
  const settingCommerce = useSelector((state) => state.setting.settingCommerce);
  const hasUserPreferenceTheme = useSelector(
    (state) => state.theme.hasUserPreferenceTheme
  );
  const token = useSelector((state) => state.fetch.token);
  const [menuItemsC, setMenuItemsC] = useState([]);
  let minWidthToEnableMobileImage = 425;

  const logo = useMemo(
    () =>
      windowWidth <= minWidthToEnableMobileImage &&
      settingCommerce?.url_image_topo_mobile
        ? settingCommerce?.url_image_topo_mobile
        : settingCommerce?.url_image_topo,
    [
      windowWidth,
      settingCommerce?.url_image_topo_mobile,
      settingCommerce?.url_image_topo,
    ]
  );

  const backgroundHeader = useMemo(
    () =>
      windowWidth <= minWidthToEnableMobileImage &&
      settingCommerce?.url_image_topo_background_mobile
        ? settingCommerce?.url_image_topo_background_mobile
        : settingCommerce?.url_image_topo_background,
    [
      windowWidth,
      settingCommerce?.url_image_topo_background_mobile,
      settingCommerce?.url_image_topo_background,
    ]
  );

  const {
    data: menuDataF,
    fetchData: fetchMenuDataF,
    isLoading: isLoadingMenuDataF,
  } = useFetchApi(
    Config.baseURL +
      `api/${selectedLang}/template/header/all/menu?centro_custo_id=${center_cost_id}`
  );

  const {
    data: settingLogin,
    fetchData: fetchSetting,
    isLoading: isLoadingSettingLogin,
  } = useFetchApi(
    Config.baseURL +
      `api/${selectedLang}/setting?centro_custo_id=${center_cost_id}&${configurator.LOGIN}`
  );

  const { data: settingCourse, fetchData: fetchSettingCourse } = useFetchApi(
    Config.baseURL +
      `api/${selectedLang}/setting-course-commerce/setting?centro_custo_id=${center_cost_id}`
  );

  const { data: dataCenterCost, fetchData: fetchcenterCost } = useFetchApi(
    Config.baseURL +
      `api/${selectedLang}/center-cost/${
        routeParams?.cc ? routeParams.cc : center_cost_id
      }`
  );

  const onLogout = () => {
    dispatch(auth.actions.logout());
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const getFaviconEl = () => {
    return document.getElementById("favicon");
  };

  const { data: inscricoesApi, fetchData: fetchInscricoes } = useFetchApi(
    Config.baseURL +
      `api/${selectedLang}/subscription/pending?pessoa_id=${
        user.data && user.data.id
      }&origem_inscricao=5`
  );

  const associationId = useAssociationId();

  const { data: statusAssociated, fetchData: fecthStatusAssociated } =
    useFetchApi(
      buildStatusAssociatedUrl({
        language: selectedLang,
        associationId,
        centerCostId: routeParams?.cc ? routeParams.cc : center_cost_id,
      })
    );

  const { data: category, fetchData: fecthCategory } = useFetchApi(
    Config.baseURL +
      `api/${selectedLang}/center-cost-person/category-person?person_id=${
        user.data && user.data.id
      }&center_cost_id=${routeParams?.cc ? routeParams.cc : center_cost_id}`
  );

  useEffect(() => {
    fetchSetting();
    fetchMenuDataF();
    fetchcenterCost();
    if (token) {
      fetchSettingCourse(null, null, {
        Authorization: "Bearer " + token,
      });
    }
    if (user.data) {
      fetchInscricoes();
      fecthCategory();
    }
    if (associationId) {
      fecthStatusAssociated();
    }
  }, [
    user,
    associationId,
    fecthCategory,
    fecthStatusAssociated,
    fetchInscricoes,
    fetchSettingCourse,
    token,
    fetchMenuDataF,
    fetchSetting,
  ]);

  useEffect(() => {
    if (inscricoesApi?.data) {
      dispatch(
        offers.actions.setShoppingCarts(
          inscricoesApi.data.filter(
            (res) => res.controle_boleto_cartao_id === null
          )
        )
      );
    }
  }, [dispatch, inscricoesApi]);

  useEffect(() => {
    if (routeParams?.cc) {
      dispatch(auth.actions.setCenterCost(routeParams.cc));
    }
  }, [routeParams?.cc]);

  useEffect(() => {
    if (menuDataF) {
      if (!menuDataF.menu_principal?.length) {
        dispatch(
          settingRedux.actions.setSettingCommerce({ customMenu: undefined })
        );
        return;
      }
      let customMenu = [];
      menuDataF.menu_principal.map((item) => {
        return (customMenu[item.menu_order] = item);
      });
      dispatch(
        settingRedux.actions.setSettingCommerce({
          customMenu: customMenu.filter((row) => row != null),
        })
      );
      setMenuItemsC(customMenu);
    }
  }, [menuDataF]);

  const getSocialMedia = (setting) => {
    if (!setting?.json_menu) return [];
    let menu = [];
    try {
      menu = [...JSON.parse(setting?.json_menu)];
    } catch (error) {
      return [];
    }
    let socialMedia = [];
    for (const { description, url } of menu) {
      if (description === "::whatsapp") {
        socialMedia.push({
          icon: '<i class="fa-brands fa-whatsapp"></i>',
          description: "Suporte whatsapp",
          url,
        });
      }
      if (description === "::telefone") {
        let phoneNumber = url.split("+")[1];
        socialMedia.push({
          icon: '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="M798-120q-125 0-247-54.5T329-329Q229-429 174.5-551T120-798q0-18 12-30t30-12h162q14 0 25 9.5t13 22.5l26 140q2 16-1 27t-11 19l-97 98q20 37 47.5 71.5T387-386q31 31 65 57.5t72 48.5l94-94q9-9 23.5-13.5T670-390l138 28q14 4 23 14.5t9 23.5v162q0 18-12 30t-30 12ZM241-600l66-66-17-94h-89q5 41 14 81t26 79Zm358 358q39 17 79.5 27t81.5 13v-88l-94-19-67 67ZM241-600Zm358 358Z"/></svg>',
          description: phoneNumber
            ? formatPhoneNumber.formatBrazilianPhoneNumber(phoneNumber)
            : "-",
          url,
        });
      }
      if (description === "::sugestoes") {
        socialMedia.push({
          icon: '<i class="fa-regular fa-circle-question"></i>',
          description: "Sugestões",
          url,
        });
      }
    }
    return socialMedia;
  };

  useEffect(() => {
    if (settingCourse) {
      const socialMedia = getSocialMedia(settingCourse?.data);
      dispatch(settingRedux.actions.setSocialMedia(socialMedia));
      dispatch(settingRedux.actions.setSettingCommerce(settingCourse?.data));
    }

    if (settingCourse?.data?.texto_aba_navegador) {
      document.title = settingCourse?.data?.texto_aba_navegador;
    }

    if (settingCourse?.data?.icone_aba_navegador) {
      getFaviconEl().href = settingCourse?.data?.icone_aba_navegador;
    }
    if (settingCourse?.data?.json_cores_barra_menu) {
      let jsonColorsMenuBar = JSON.parse(
        settingCourse?.data?.json_cores_barra_menu
      );
      if (
        jsonColorsMenuBar.hasOwnProperty("defaultThemeMode") &&
        !hasUserPreferenceTheme
      ) {
        dispatch(themeRedux.actions.setHasPreferenceTheme(true));
        dispatch(
          themeRedux.actions.setSystemTheme(jsonColorsMenuBar.defaultThemeMode)
        );
      }
    }
  }, [settingCourse, dispatch]);

  useEffect(() => {
    if (dataCenterCost) {
      dispatch(settingRedux.actions.setCenterCost(dataCenterCost));
    }
  }, [dataCenterCost]);

  useEffect(() => {
    dispatch(
      settingRedux.actions.setIsLoadingSettingLogin(isLoadingSettingLogin)
    );
    if (settingLogin?.data)
      dispatch(settingRedux.actions.setSettingLogin(settingLogin.data));
  }, [settingLogin, isLoadingSettingLogin]);

  useEffect(() => {
    if (statusAssociated?.data) {
      dispatch(
        auth.actions.updateUser({
          ...user,
          data: { ...user?.data, ...statusAssociated?.data },
        })
      );
    }
  }, [statusAssociated?.data?.financialStatus, dispatch]);

  return (
    <div className="layout-container">
      <Grid className="topo-full" item={true} md={12}>
        <div className="layout-fixed">
          <Header
            statusAssociated={statusAssociated}
            category={category?.data?.descricao}
            user={user}
            client={settingCommerce?.texto_aba_navegador}
            logo={logo}
            backgroundHeader={backgroundHeader}
            shoppingCarts={shoppingCarts}
            menuItemsC={menuItemsC}
            goTo={goTo}
            onLogout={onLogout}
            isLoadingMenuData={isLoadingMenuDataF}
            center_cost_id={routeParams?.cc ? routeParams.cc : center_cost_id}
            anchorEl={anchorEl}
            setting={settingLogin}
            handleClick={handleClick}
            handleClose={handleClose}
          />
        </div>
      </Grid>
      {mobileReturn?.page && (
        <MobileReturn
          page={mobileReturn?.page}
          onClick={mobileReturn?.onClick}
        />
      )}
      {isLoading && <LinearProgress className={styles.LinearProgress} />}
      <Box className={`body-layout-container ${bodyClassname}`} p={3}>
        <Container maxWidth="xl" className="body-layout" spacing={2}>
          {children}
        </Container>
      </Box>
      <Footer />
    </div>
  );
};

export default Layout;
